import React from 'react'
import PropTypes from 'prop-types'
import { isSelectedPass, asTimeDiff, iconFromStatus, sortLowToHighByAttribute } from '../util/selectors'
import { PASS_STATUS, PASS_STATUS_STYLE } from '../util/constants'
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'
import Icon from '@material-ui/core/Icon'
const LATEST = ".LATEST"
const styles = theme => ({
  item: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  [`${PASS_STATUS.CREATED}`]: {
    backgroundColor: theme.palette.primary[PASS_STATUS_STYLE.CREATED],
    color: "#fff"
  },
  [`${PASS_STATUS.REGISTERED}`]: {
    backgroundColor: theme.palette.primary[PASS_STATUS_STYLE.REGISTERED],
    color: "#fff"
  },
  [`${PASS_STATUS.REDEEMED}`]: {
    backgroundColor: theme.palette.primary[PASS_STATUS_STYLE.REGISTERED],
    color: "#fff"
  },
  [`${PASS_STATUS.CREATED}${LATEST}`]: {
    backgroundColor: theme.palette.secondary[PASS_STATUS_STYLE.CREATED],
    color: "#fff"
  },
  [`${PASS_STATUS.REGISTERED}${LATEST}`]: {
    backgroundColor: theme.palette.secondary[PASS_STATUS_STYLE.REGISTERED],
    color: "#fff"
  },
  [`${PASS_STATUS.REDEEMED}${LATEST}`]: {
    backgroundColor: theme.palette.secondary[PASS_STATUS_STYLE.REGISTERED],
    color: "#fff"
  }
});
const HistoryList = ({ classes, selectedPassId, history }) => {
  const latestEvent = {};
  sortLowToHighByAttribute(history, 'timestamp').forEach(({ pass_id, timestamp }) => {
    latestEvent[pass_id] = timestamp;
  });
  return (
    <div className={classes.item}>
      <List>
        {history.filter(isSelectedPass(selectedPassId)).map(({ description, timestamp, status, pass_id }, key) => {
          const timeDiff = asTimeDiff(timestamp)
          const icon = iconFromStatus(status)
          const _latest = latestEvent[pass_id] === timestamp ? LATEST : ""
          return (
            <ListItem key={key}>
              <Avatar className={classes[`${status}${_latest}`]}>
                <Icon >
                  {icon}
                </Icon>
              </Avatar>
              <ListItemText primary={`${description}`} secondary={timeDiff} />
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}

HistoryList.propTypes = {
  history: PropTypes.arrayOf(PropTypes.shape({
    timestamp: PropTypes.string.isRequired,
    pass_id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  })),
  classes: PropTypes.object.isRequired,
  selectedPassId: PropTypes.string
}

export default withStyles(styles)(HistoryList);


// WEBPACK FOOTER //
// ./src/components/history-list.js